import React from 'react';
import styled from 'astroturf/react';

import { currentUser } from 'js/utils/user';
import _PremiumLockSvg from "PremiumLock-PremiumLockSvg.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/header/FocusedNav/PremiumLock.tsx?styleId=PremiumLockSvg";


const DEFAULT_WIDTH = 22;

type Color = 'transparent' | 'gold' | 'blue' | 'white';

const getColor = (color: Color) => {
  switch (color) {
    case 'transparent':
      return 'transparent';
    case 'gold':
      return 'var(--premium-dark, #877440)';
    case 'blue':
      return 'var(--primary-brand, #0645b1)';
    case 'white':
      return 'white';
    default: {
      const _exhaustiveCheck: never = color;
      return _exhaustiveCheck;
    }
  }
};

const PremiumLockSvg = /*#__PURE__*/styled("svg", null, {
  displayName: "PremiumLockSvg",
  styles: _PremiumLockSvg
});

type Props = {
  width?: number;
  circleColor?: Color;
  lockColor?: Color;
};

const PremiumLock = ({
  width = DEFAULT_WIDTH,
  circleColor = 'transparent',
  lockColor = 'gold',
}: Props) => {
  if (currentUser?.premium) {
    return null;
  } else {
    return (
      <PremiumLockSvg
        style={
          {
            '--premium-lock-width': `${width}px`,
          } as React.CSSProperties
        }
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="10" cy="10" r="10" fill={getColor(circleColor)} />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.51217 6.82601C7.51217 5.33024 8.72473 4.11768 10.2205 4.11768C11.7163 4.11768 12.9288 5.33024 12.9288 6.82601V8.07601C12.9288 8.2177 12.918 8.35685 12.897 8.49268H13.1371C13.5974 8.49268 13.9705 8.86577 13.9705 9.32601V13.9093C13.9705 14.3696 13.5974 14.7427 13.1371 14.7427H7.30379C6.84355 14.7427 6.47046 14.3696 6.47046 13.9093V9.32601C6.47046 8.86577 6.84355 8.49268 7.30379 8.49268H7.54402C7.52305 8.35685 7.51217 8.2177 7.51217 8.07601V6.82601ZM11.6788 8.49268H8.76217V7.03434C8.76217 6.22893 9.41509 5.57601 10.2205 5.57601C11.0259 5.57601 11.6788 6.22893 11.6788 7.03434V8.49268Z"
          fill={getColor(lockColor)}
        />
      </PremiumLockSvg>
    );
  }
};

export default PremiumLock;
